import {
  Grid,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormControlLabel,
  Checkbox,
  TextField,
} from '@material-ui/core';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useStyles } from './styles';
import { useStore } from 'hooks/useRootStore';
import { useMutation, useQuery } from 'react-query';
import { InvitationFormProps } from '../../types';
import { useAppPreloader } from 'hooks/useAppPreloader';
import headerlogo from '../../../../../assets/icons/logo.svg';
import EmailHeader from 'components/EmailHeader/EmailHeader';
// import { DefaultTreeExplorer } from 'components/BaseTreeExplorer/DefaultTreeExplorer';
import { observer } from 'mobx-react-lite';
import { SelectedList } from '../types';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { useHistory } from 'react-router-dom';
export const Groups: FC<InvitationFormProps> = observer(({ step, open, refetch, handleClose, emailtemps }) => {
  const classes = useStyles();
  const history = useHistory();
  const [registrationStep, setRegistrationStep] = useState(true);
  const [SelectAll, setSelectAll] = useState(false);
  const [selectedList, setSelectedList] = useState<SelectedList[]>([]);
  const {
    ldapStore: { getGroups, allGroupsView },
    userStore: { user },
    invitationStore: { sendGroupInvitation, sendGroupStepone },
    emailTemplatesTableStore: { getEmail, emailtemp },
    notificationStore: { openNotification },
    baseTreeExplorerStore: { getInternalFilterBaseLink, getInternalBaseLinkGroup },
    appPreloaderStore: { disablePreloader },
  } = useStore();
  const getGroupsReq = useQuery('getGroupsReq', () => getGroups(), {
    onError: () => openNotification('error', `Can't get groups`),
  });

  const getEmailTemplateReq = useQuery('getEmailTemplateReq', () => getEmail(), {
    onError: () => openNotification('error', `Can't get upgrade license info`),
  });

  const sendGroupInvitationReq = useMutation((data: any) => sendGroupInvitation(data), {
    mutationKey: 'sendInvitationReq',
    onSuccess: (e) => {
      openNotification('success', `${e}`);
      refetch();
      reset();
      setRegistrationStep(false);
      emailtemps(registrationStep);
      handleClose();
      disablePreloader();
    },
    onError: (error: any) => {
      let errorMessage = 'An error occurred';

      if (error?.response?.data?.data?.message) {
        errorMessage = error.response.data.data.message;
      } else if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error?.data?.data?.message) {
        errorMessage = error.data.data.message;
      } else if (error?.data?.message) {
        errorMessage = error.data.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      openNotification('error', errorMessage);
      disablePreloader();
    },
  });

  const sendGroupSteponeReq = useMutation((data: any) => sendGroupStepone(data), {
    mutationKey: 'sendGroupStepReq',
    onError: (e) => openNotification('error', `${e}`),
  });
  const { control, handleSubmit, reset } = useForm<any>();
  const sample = ['Update Password'];
  useEffect(() => {
    setSelectAll(false);
    setSelectedList([]);
  }, [getInternalFilterBaseLink]);

  const onSubmit2 = (data: any) => {
    if (data.SelectAll === true) {
      data = Object.fromEntries(Object.entries(data).map(([key, value]) => [key, true]));
      data.SelectAll = false;
    }
    const pass = [
      { inviteType: data.inviteType === undefined ? 'register' : data.inviteType },
      {
        templateSubjectPass:
          data.templateSubjectPass === undefined ? data.templateSubjectPass : data.templateSubjectPass,
      },
      { templateBodyPass: data.templateBodyPass === undefined ? data.templateBodyPass : data.templateBodyPass },
      { templateButtonPass: data.templateButtonPass === undefined ? data.templateButtonPass : data.templateButtonPass },
      {
        templateSignatureNamePass:
          data.templateSignatureNamePass === undefined
            ? data.templateSignatureNamePass
            : data.templateSignatureNamePass,
      },
      {
        templateSignaturePositionPass:
          data.templateSignaturePositionPass === undefined
            ? data.templateSignaturePositionPass
            : data.templateSignaturePositionPass,
      },
    ];
    const newData = Object.keys(data)
      .filter((key) => data[key] === true)
      .map((key) => key);
    const arr: any = [];

    newData.map((item: any) => {
      return filterateGroup.map((nitem: any) => {
        return nitem.dn === item && arr.push(nitem.memberuid);
      });
    });

    const merge: any = [...arr, ...pass];
    sendGroupInvitationReq.mutate(merge);
  };
  const CheckListUpdater = (value: boolean, fieldIndex: any, data: any) => {
    if (!value) {
      setSelectedList((prevSelectedList) => prevSelectedList.filter((element) => element.data !== data));
      setSelectAll(false);
    } else {
      setSelectedList((prevSelectedList) => [
        ...prevSelectedList,
        { value: value, fieldIndex: fieldIndex, data: data },
      ]);
      if (selectedList.length + 1 === allGroupsView.length) {
        setSelectAll(true);
      }
    }
  };

  const filterateGroup = useMemo(
    () =>
      allGroupsView
        .map((data: any) => (data.base === getInternalFilterBaseLink ? data : false))
        .filter((data: any) => data !== false)
        .filter((data) => data.memberuid.length > 1),
    [allGroupsView, getInternalFilterBaseLink]
  );

  const onSubmit = (data: any) => {
    const inviteTypeData = data.inviteType === undefined ? sample[0] : data.inviteType;
    if (data.SelectAll === true) {
      data = Object.fromEntries(Object.entries(data).map(([key, value]) => [key, true]));
      data.SelectAll = false;
      data.inviteType = inviteTypeData;
    }

    data.inviteType = data.inviteType === undefined ? sample[0] : data.inviteType;

    const newData = Object.keys(data)
      .filter((key) => data[key] === true)
      .map((key) => key);
    const arr: any = [];

    newData.forEach((item) =>
      filterateGroup.forEach((filterItem: any) => {
        if (filterItem.dn === item) {
          arr.push(filterItem.memberuid);
        }
      })
    );

    setRegistrationStep(!registrationStep);
    emailtemps(registrationStep);

    sendGroupSteponeReq.mutate(arr);
  };

  step(registrationStep);
  useAppPreloader(getGroupsReq.isFetching || sendGroupInvitationReq.isLoading || getEmailTemplateReq.isLoading);
  const handleCheckSelectAll = (e: any) => {
    if (e.target.checked) {
      const updatedSelectedList = allGroupsView.map((obj: any, index) => ({
        value: e.target.checked,
        fieldIndex: index,
        data: obj.cn,
      }));
      setSelectedList(updatedSelectedList);
    } else {
      setSelectedList([]);
    }
    setSelectAll(e.target.checked);
  };

  return (
    <>
      {registrationStep === true && (
        <form onSubmit={handleSubmit(onSubmit)} className={classes.formContainer}>
          <Controller
            name='inviteType'
            control={control}
            defaultValue={sample[0]}
            render={({ field, fieldState: { invalid } }) => (
              <Grid className={classes.inviterow} container>
                <FormControl className={classes.input}>
                  <InputLabel>Invitation type :</InputLabel>
                  <Select {...field} defaultValue={sample[0]} error={invalid} className={classes.input}>
                    {sample.map((_item: any) => (
                      <MenuItem key={_item} value={_item}>
                        {_item}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          />
          {/* <p>Departments List</p>

          <DefaultTreeExplorer /> */}
          {getInternalBaseLinkGroup ? (
            <div style={{ marginTop: '10px' }}>
              <InputLabel className={classes.selectiontitle}>Select Group</InputLabel>
              <div className={classes.selectOption}>
                {!getGroupsReq.isFetching && (
                  <>
                    <Grid className={classes.row} container>
                      {allGroupsView.length === 0 ? (
                        <>
                          <div className={classes.text}>
                            <span> No Group Found. </span>
                            <Button
                              className={classes.addBtn}
                              onClick={() => history.push(handleCompanyUrl('/group/add'))}
                            >
                              Add Group
                            </Button>
                          </div>
                        </>
                      ) : allGroupsView.length ? (
                        <FormControlLabel
                          key={'Select All'}
                          control={
                            <Controller
                              defaultValue={false}
                              name={'SelectAll'}
                              control={control}
                              render={({ field, fieldState: { invalid, error } }) => (
                                <Checkbox
                                  {...field}
                                  name={`label Select All`}
                                  checked={SelectAll}
                                  onChange={(e: any) => {
                                    field.onChange(e);
                                    handleCheckSelectAll(e);
                                  }}
                                />
                              )}
                            />
                          }
                          label={'Select All'}
                        />
                      ) : null}
                      {allGroupsView
                        // .map((data: any) => (data.base === getInternalFilterBaseLink ? data : false))
                        // .filter((data: any) => data !== false)
                        // .filter((data) => data.memberuid.length > 1)
                        .map((index, i) => (
                          <FormControlLabel
                            key={index.id}
                            control={
                              <Controller
                                defaultValue={false}
                                name={index.dn}
                                control={control}
                                render={({ field, fieldState: { invalid, error } }) => (
                                  <Checkbox
                                    {...field}
                                    name={`label${i}`}
                                    checked={selectedList.some((item) => item.data === index.cn)}
                                    onChange={(e: any) => {
                                      field.onChange(e);
                                      CheckListUpdater(e.target.checked, i, index.cn);
                                    }}
                                  />
                                )}
                              />
                            }
                            label={index.cn}
                          />
                        ))}
                    </Grid>
                  </>
                )}
              </div>
              <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn}>
                <Grid className={classes.block} container>
                  <Grid item xs={6} container className={classes.btnrow}>
                    <Button
                      className={classes.btn1}
                      onClick={() => {
                        handleClose();
                      }}
                      fullWidth
                      variant='contained'
                      color='primary'
                    >
                      Cancel
                    </Button>
                  </Grid>
                  <Grid item xs={6} container className={classes.btnrow}>
                    <Button
                      className={classes.btn2}
                      type='submit'
                      fullWidth
                      variant='contained'
                      color='secondary'
                      disabled={!selectedList.length}
                    >
                      Next
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          ) : null}
        </form>
      )}

      {registrationStep === false && (
        <form onSubmit={handleSubmit(onSubmit2)} className={classes.formContainer}>
          <Grid>
            <Grid item container xs={12} className={classes.emailHeader}>
              <img src={headerlogo} alt='' />
            </Grid>
            <Grid className={classes.labels}>
              <p>Hello!</p>
            </Grid>
            {getEmailTemplateReq.isLoading && (
              <Grid className={classes.details}>
                <Controller
                  key='1'
                  name='templateSubjectReg'
                  control={control}
                  defaultValue='I am inviting you to create a new user password at:'
                  rules={{ required: false }}
                  render={({ field, fieldState: { invalid } }) => (
                    <Grid container>
                      <TextField
                        {...field}
                        error={invalid}
                        placeholder='I am inviting you to create a new user password at:'
                        defaultValue='I am inviting you to create a new user password at:'
                        helperText={invalid ? 'Required field' : ''}
                        className={classes.input}
                        multiline
                        rows={2}
                        InputProps={{ disableUnderline: true }}
                      />
                    </Grid>
                  )}
                />
              </Grid>
            )}
            <Grid className={classes.details}>
              {emailtemp.map((mail) => (
                <>
                  {mail.template === 'password' && (
                    <Controller
                      key='1'
                      defaultValue={mail.templateSubject}
                      name='templateSubjectPass'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='I am inviting you to create a new user password at:'
                            defaultValue={mail.templateSubject}
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            multiline
                            rows={2}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}
                </>
              ))}

              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateBodyReg'
                    defaultValue='I am inviting you'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder='I am inviting you'
                          defaultValue='I am inviting you'
                          helperText={invalid ? 'Required field' : ''}
                          className={classes.input}
                          multiline
                          rows={2}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}

                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateBodyPass'
                        defaultValue={mail.templateBody}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder='I am inviting you to create a new user password at:'
                              defaultValue={mail.templateBody}
                              helperText={invalid ? 'Required field' : ''}
                              className={classes.input}
                              multiline
                              rows={2}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid>
            <Grid className={classes.emailbtn}>
              <Grid item xs={6} container className={classes.btndetails}>
                <Button fullWidth variant='contained' color='primary'>
                  {getEmailTemplateReq.isLoading && (
                    <Controller
                      key='1'
                      name='templateButtonReg'
                      defaultValue='Create an account'
                      control={control}
                      rules={{ required: false }}
                      render={({ field, fieldState: { invalid } }) => (
                        <Grid container className={classes.btn1}>
                          <TextField
                            {...field}
                            error={invalid}
                            placeholder='Create an account'
                            defaultValue='Create an account'
                            helperText={invalid ? 'Required field' : ''}
                            className={classes.input}
                            InputProps={{ disableUnderline: true }}
                          />
                        </Grid>
                      )}
                    />
                  )}

                  {emailtemp.map((mail) => (
                    <>
                      {mail.template === 'password' && (
                        <Controller
                          key='1'
                          name='templateButtonPass'
                          defaultValue='Update Password'
                          control={control}
                          rules={{ required: false }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.btn1}>
                              <TextField
                                {...field}
                                error={invalid}
                                placeholder='Update Password'
                                defaultValue='Update Password'
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                                InputProps={{ disableUnderline: true }}
                              />
                            </Grid>
                          )}
                        />
                      )}
                    </>
                  ))}
                </Button>
              </Grid>
            </Grid>
            <Grid className={classes.system}>
              <p className={classes.thanks}>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignatureNameReg'
                    defaultValue={`Thanks ${user?.name} ${user?.lastName}`}
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.thanks}>
                        <TextField
                          {...field}
                          error={invalid}
                          placeholder={`Thanks ${user?.name} ${user?.lastName}`}
                          defaultValue={`Thanks ${user?.name} ${user?.lastName}`}
                          helperText={invalid ? 'Required field' : ''}
                          className={`${classes.input} `}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}

                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignatureNamePass'
                        defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.thanks}>
                            <TextField
                              {...field}
                              error={invalid}
                              placeholder={`Thanks, ${user?.name} ${user?.lastName}`}
                              defaultValue={`Thanks, ${user?.name} ${user?.lastName}`}
                              helperText={invalid ? 'Required field' : ''}
                              className={`${classes.input} `}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
              <p>
                {getEmailTemplateReq.isLoading && (
                  <Controller
                    key='1'
                    name='templateSignaturePositionPass'
                    defaultValue=' System Administrator'
                    control={control}
                    rules={{ required: false }}
                    render={({ field, fieldState: { invalid } }) => (
                      <Grid container className={classes.admin}>
                        <TextField
                          {...field}
                          placeholder=' System Administrator'
                          defaultValue=' System Administrator'
                          helperText={invalid ? 'Required field' : ''}
                          className={` ${classes.input}`}
                          InputProps={{ disableUnderline: true }}
                        />
                      </Grid>
                    )}
                  />
                )}
                {emailtemp.map((mail) => (
                  <>
                    {mail.template === 'password' && (
                      <Controller
                        key='1'
                        name='templateSignaturePositionPass'
                        defaultValue={user?.permission}
                        control={control}
                        rules={{ required: false }}
                        render={({ field, fieldState: { invalid } }) => (
                          <Grid container className={classes.admin}>
                            <TextField
                              {...field}
                              placeholder={user?.permission}
                              defaultValue={user?.permission}
                              helperText={invalid ? 'Required field' : ''}
                              className={` ${classes.input}`}
                              InputProps={{ disableUnderline: true }}
                            />
                          </Grid>
                        )}
                      />
                    )}
                  </>
                ))}
              </p>
            </Grid>
            <EmailHeader
              ImageUrl={emailtemp[0].templateProfileImageUrl ?? ''}
              EmailUrl={emailtemp[0].templateAdminEmail ?? ''}
              OrganizationName={emailtemp[0].templateOrganizationName ?? ''}
            />
          </Grid>
          <Grid container justify='space-between' alignItems='center' className={classes.bottomBtn1}>
            <Grid className={classes.block} container>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button
                  className={classes.btn1}
                  onClick={() => {
                    setRegistrationStep(!registrationStep);
                    emailtemps(registrationStep);
                    setSelectAll(false);
                    setSelectedList([]);
                    reset();
                  }}
                  fullWidth
                  variant='contained'
                  color='primary'
                >
                  Back
                </Button>
              </Grid>
              <Grid item xs={6} container className={classes.btnrow}>
                <Button className={classes.btn2} type='submit' fullWidth variant='contained' color='secondary'>
                  Confirm & send invite
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  );
});
